import apiClient from './api';

/**
 * Servicio para gestionar Tests DISC
 */
export const testDiscService = {
  /**
   * Procesar y guardar un test DISC
   * @param {Object} testData - { usuarioId, procesoId, perfilId, respuestasMas, respuestasMenos }
   */
  procesarTest: async (testData) => {
    const response = await apiClient.post('/disc/procesar', testData);
    return response.data;
  },

  /**
   * Obtener test por ID
   * @param {number} id - ID del test
   */
  getTestById: async (id) => {
    const response = await apiClient.get(`/disc/${id}`);
    return response.data;
  },

  /**
   * Obtener tests por usuario
   * @param {number} usuarioId - ID del usuario
   */
  getTestsByUsuario: async (usuarioId) => {
    const response = await apiClient.get(`/disc/usuario/${usuarioId}`);
    return response.data;
  },

  /**
   * Obtener historial de tests por DNI
   * @param {string} dni - DNI del usuario
   */
  getHistorialByDni: async (dni) => {
    const response = await apiClient.get(`/disc/historial/dni/${dni}`);
    return response.data;
  },

  /**
   * Obtener tests por proceso
   * @param {number} procesoId - ID del proceso
   */
  getTestsByProceso: async (procesoId) => {
    const response = await apiClient.get(`/disc/proceso/${procesoId}`);
    return response.data;
  },

  /**
   * Obtener todos los tests
   */
  getAllTests: async () => {
    const response = await apiClient.get('/disc/todos');
    return response.data;
  },

  /**
   * Obtener historial completo ordenado por fecha
   */
  getHistorialCompleto: async () => {
    const response = await apiClient.get('/disc/historial/completo');
    return response.data;
  }
};

export default testDiscService;
